module.exports = __webpack_public_path__ + "static/media/min_black.25135f07.png";